import { VALIDATION_MESSAGE } from '../ValidationMessage';
import yup from './CustomValidation/yup-extended';

export const LITERACY_SCREENING_EXPLANATION_MAX_LENGTH = 200;

export interface LiteracyScreeningReimbursementFormValues {
  reimbursement: string;
  explanation: string;
}

export const LiteracyScreeningReimbursementValidationSchema = yup
  .object()
  .shape({
    reimbursement: yup.string().required(VALIDATION_MESSAGE.REQUIRED),
    explanation: yup
      .string()
      .max(
        LITERACY_SCREENING_EXPLANATION_MAX_LENGTH,
        VALIDATION_MESSAGE.AT_MOST_CHARS(
          LITERACY_SCREENING_EXPLANATION_MAX_LENGTH
        )
      )
      .test(
        'explanation-required-when-no',
        VALIDATION_MESSAGE.LITERACY_SCREENING_EXPLANATION_REQUIRED,
        function (value) {
          if (this.parent.reimbursement !== 'No') {
            return true;
          }
          return Boolean(value);
        }
      ),
  });
